export const getSocketServerUrl = () => {
  if (process.env.REACT_APP_SOCKET_URL) {
    return process.env.REACT_APP_SOCKET_URL;
  }

  const explicitPort ='8080';

  if (process.env.REACT_APP_API_URL) {
    try {
      const apiUrl = new URL(process.env.REACT_APP_API_URL);
      const protocol = apiUrl.protocol === 'https:' ? 'wss' : 'ws';
      return `${protocol}://${apiUrl.hostname}:${explicitPort}`;
    } catch {
      // Fall through to hostname-based defaults.
    }
  }

  if (window.location.hostname === 'pos.kanaiyacosmetics.com') {
    return `wss://backend.kanaiyacosmetics.com:${explicitPort}`;
  }

  const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
  return `${protocol}://${window.location.hostname}:${explicitPort}`;
};
